import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import toonflix from "../images/toonflix.jpg";
import axios from "axios";
import Cookies from "js-cookie";
import Select from 'react-select';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { base_url_toonflix } from "../Api/api";


const Login = () => {
  const [number, setNumber] = useState("");
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);
  const [headersNumber, setHeadersNumber] = useState('');
  const [selectedOption, setSelectedOption] = useState({ value: 'daily', label: 'Tous les jours/100 FCFA' });

  const urlParams = new URLSearchParams(window.location.search);
  const msisdn = urlParams.get('msisdn');
  let ExtId = urlParams.get('extId') || generateUniqueAlphabetId();
  const Ext_params = urlParams.get('extId');

  function generateUniqueAlphabetId(length = 22) {
    const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz';
    let result = '';
    for (let i = 0; i < length; i++) {
      const randomIndex = Math.floor(Math.random() * characters.length);
      result += characters[randomIndex];
    }
    return result;
  }

  console.log('msisdn from URL:', msisdn);

  const navigate = useNavigate();

  const options = [
    { value: 'daily', label: 'Tous les jours/100 FCFA' },
    { value: 'weekly', label: 'Hebdomadaire/300 FCFA' },
    { value: 'monthly', label: 'Mensuelle/500 FCFA' },
  ];

  const customStyles = {
    control: (provided, state) => ({
      ...provided,
      borderColor: state.isFocused ? 'rgb(234 88 12)' : 'gray',
      boxShadow: state.isFocused ? '0 0 0 1px rgb(234 88 12)' : 'none',
      '&:hover': {
        borderColor: state.isFocused ? 'rgb(234 88 12)' : 'gray',
      },
    }),
  };

  Cookies.set('extId', ExtId);

const checkUser = async () => {
  try {
    const num = Cookies.get('number');
    console.log(num);

    if (!num) return;

    const res = await axios.get(`${base_url_toonflix}/api/v1/check-status?msisdn=${num}&serviceName=ToonFlix`);

    if (res.status === 200) {
      toast.success(res.data?.message || 'Abonnement actif');
      navigate('/home');
    }

  } catch (err) {
    console.log(err);

    const status = err?.response?.status;
    const msg = err?.response?.data?.message;

    if (status === 400) {
      toast.error(msg || 'Requête invalide, veuillez réessayer.');
      navigate('/subscribe');
    }

    if (status === 500) {
      toast.error(msg || 'Erreur serveur, veuillez réessayer plus tard.');
      navigate('/subscribe');
    }
  }
};

useEffect(() => {
  checkUser();
}, []);

 

  // ─── Send OTP via POST /api/v1/send ───────────────────────────────────────
  const handle = async (e) => {
    e.preventDefault();
    setLoading(true);

    if (!number) {
      toast.warn("Veuillez d'abord entrer le numéro!!");
      setLoading(false);
      return;
    }

    // Cookies.set('number', number);
    // Cookies.set('pack', selectedOption.value);

    try {
      const res = await axios.post(`${base_url_toonflix}/api/v1/send`, {
        msisdn: number,
        serviceName: "ToonFlix"
      });

      console.log("Send OTP response:", res.data);




    if (res.status === 200) {
        toast.success('OTP envoyé avec succès!!');
          Cookies.set('number', number, { expires: 6/24 })
      Cookies.set('pack', selectedOption.value, { expires: 6/24 })
        // otpId is expected in res.data.data (ApiResponseDto)
        const otpId = res.data?.data?.otpId || res.data?.data || res.data;

        setTimeout(() => {
          navigate(`/otp-validation?otpId=${otpId}`);
        }, 1000);
      }
    // } catch (err) {
    //   console.log(err);
    //   toast.error(err?.response?.data?.message || "Échec de l'envoi de l'OTP !");
    // }

} catch (err) {
    console.log(err);

    if (err.response?.status === 400) {
        toast.error(err.response?.data?.message || "Bad Request");
    } else if (err.response?.status === 500) {
        toast.error(err.response?.data?.message || "Internal Server Error");
    } else {
        toast.error("Something went wrong");
    }
}

    setLoading(false);
  };

  return (
    <div className="fixed inset-0 overflow-y-auto bg-black/90 flex justify-center items-center z-10">
      <div className="container mx-auto max-w-screen-sm bg-white rounded-md p-4 md:p-8 flex flex-col items-center shadow-lg relative">
        <img
          src={toonflix}
          alt="/"
          className="w-24 h-auto mb-4 md:mb-0 md:w-[200px]"
        />

        <p className="text-end text-md font-bold ml-24">-Service fourni par Panz</p>

        <form className="flex flex-col w-full px-4 py-2">
          <div className="text-center flex flex-col items-center">
            <h1 className="text-2xl md:text-3xl font-bold">
              Cliquez à
              <span className="text-orange-600 font-bold text-2xl md:text-3xl px-2">
                s'abonner
              </span>
            </h1>
            <p className="text-center w-[90%] font-bold">
              Toonflix est une plateforme de divertissement proposant des vidéos de dessins animés amusantes, éducatives et adaptées à l'âge des enfants.
            </p>
          </div>
          <>
            <p className='text-left pt-4 text-lg font-semibold'>
              {headersNumber === '' ? 'Entrez le numéro' : 'Votre numéro'}
            </p>
            <input
              type="tel"
              placeholder="ENTREZ VOTRE NUMÉRO DE TÉLÉPHONE."
              className="border border-black text-lg md:text-xl text-left p-2 mt-3 w-full h-10"
              value={number}
              onChange={(e) => setNumber(e.target.value)}
            />
          </>
          <p className='py-2 pt-4 text-lg font-semibold'>Type de paquet</p>
          <Select
            defaultValue={selectedOption}
            onChange={setSelectedOption}
            options={options}
            styles={customStyles}
          />
          {error && <p className="text-red-600 text-center mt-2">{error}</p>}
          <div className="flex mt-4 md:mt-6">
            <button
              onClick={handle}
              type='submit'
              className="w-full bg-orange-600 text-white py-2 px-4 rounded"
              disabled={loading}
            >
              {loading ? "Soumission..." : "S'abonner"}
            </button>
          </div>
          <p
            onClick={() => navigate('/tnc')}
            className="text-blue-700 text-center mt-4 underline cursor-pointer"
          >
            Conditions générales
          </p>
        </form>
        <span className='text-xs font-semibold w-full text-center'>• Désinscription gratuite à tout moment : composez #303#10#.</span>
        <span className='text-xs font-semibold w-full text-center'>•Pour toute question ou assistance, veuillez contacter notre service client ou visiter notre page d'assistance, c'est-à-direpanz.support1@panzcon.com</span>
      </div>

    </div>
  );
};

export default Login;
